<template>
  <div class="payment-paynow" :style="qrState" @click="showDetails">
    <div class="above-qr">
      <p>
        <span class="is-uppercase">{{ identifier }}</span>
        <a v-if="accountName" style="margin-left: 3px">
          {{ accountName }}
        </a>
      </p>
    </div>
    <div class="qr-wrapper">
      <qr-canvas :options="options" />
    </div>

    <div>
      <p class="has-text-dark" style="padding-top: 6px">
        Scan with your banking app, or enter PayNow
        <span class="tag is-white" @click="copyPaymentID">
          {{ identifier }}&nbsp;<i class="fa fa-copy has-text-info" />
        </span>
        with amount
        <span class="tag is-white">{{ price }}</span>
      </p>
      <!-- <p style="padding-top: 16px">After payment is complete please send the confirmation to the shop.</p> -->
    </div>
  </div>
</template>

<script>
import $Scriptjs from "scriptjs";
import { QRCanvas } from "qrcanvas-vue";
const paynow = require("paynow-generator").paynowGenerator;
// import { PaynowQR } from "paynowqr";
// const PaynowQR = require("paynowqr");

export default {
  name: "PaymentPayNow",
  components: {
    // QRCanvas,
    QrCanvas: QRCanvas,
    // PaynowQR: PaynowQR,
  },
  props: {
    refNumber: String, // reference number for the order
    businessName: String, // business name, not necessarily paynow account name
    accountName: String, // name associated with paynow account, likely business name
    paymentID: String, // UEN or mobile number
    type: String, // uen or mobile
    price: Number,
  },
  data() {
    return {
      paymentCode: null, // set later
      //   paymentTimer: false,
      //   createdBy: null,
      //   phoneNumber: null,
      //   logo: "/img/icons/round-96x96.png", // 180x180
    };
  },
  computed: {
    // paymentDone() {
    //   return this.paymentTimer;
    // },
    options() {
      return {
        cellSize: 8,
        data: this.paymentCode,
      };
    },
    identifier() {
      return this.type.toUpperCase() + " " + this.paymentID.toUpperCase();
    },
    qrState() {
      if (this.paymentCode) return null;
      return `filter: blur(5px);`;
    },
  },
  mounted() {
    if (this.type.toLowerCase() === "uen") {
      var url = `https://unpkg.com/paynowqr@latest/dist/paynowqr.min.js`;
      $Scriptjs(url, () => (this.paymentCode = this.generateUENCode()));
    } else {
      this.paymentCode = this.generateMobileCode();
    }
  },
  methods: {
    copyPaymentID() {
      this.$copyText(this.paymentID);
      setTimeout(() => this.successToast("Copied to clipboard!", "top"), 300);
    },
    showDetails() {
      var msg = this.identifier;
      if (this.accountName) msg += `<br>${this.accountName}`;
      this.infoToast(msg, "top");
    },
    // notifyBusiness() {
    //   var msg = `${this.phoneNumber} says they completed payment 🥳 Remember to call a delivery driver !! 🚚`;
    //   this.sendPushNotification(msg, this.createdBy);
    // },
    paymentCompleted() {
      this.notifyBusiness();
      this.thankYou(`${this.$t("delivery.sign-in-to-track")} 🥳🥂🦜`);
      setTimeout(() => this.goHome(), 2000);
    },
    generateMobileCode() {
      var edit = "yes";
      var shopName = "CIVILIZATION BREWING"; //"Mala House"; //this.shopName;
      var comments = "Hi"; //"Thank you for ordering with us";
      // type, id, edit, this.price, shopName, comments
      console.log("paynow mobile", this.paymentID, this.price);
      //   return paynow(type, this.paymentID, edit, this.price, shopName, comments);
      //   return paynow("mobile", "97251347", "yes", 1, "", "hello world");
      return paynow("mobile", "87893949", "yes", this.price, "", "hello world"); // doesn't work for 32.00...why?!
      //   return paynow("UEN", "53409060E", "yes", 1, "", "hello world");
      // return paynow("UEN", id, "yes", "101.6", "", "");
    },

    //Create a PaynowQR object
    generateUENCode() {
      //Create a PaynowQR object
      //   const PaynowQR = require("paynowqr");
      //   let qrcode = new PaynowQR({
      //     uen: "201403121W", //Required: UEN of company
      //     amount: 500, //Specify amount of money to pay.
      //     editable: true, //Whether or not to allow editing of payment amount. Defaults to false if amount is specified
      //     expiry: "20201231", //Set an expiry date for the Paynow QR code (YYYYMMDD). If omitted, defaults to 5 years from current time.
      //     refNumber: "TQINV-10001", //Reference number for Paynow Transaction. Useful if you need to track payments for recouncilation.
      //     company: "ACME Pte Ltd.", //Company name to embed in the QR code. Optional.
      //   });
      //   //Outputs the qrcode to a UTF-8 string format, which can be passed to a QR code generation script to generate the paynow QR
      //   let QRstring = qrcode.output();
      //   return QRstring;
      //   console.log("PaynowQR", PaynowQR);
      var code = new PaynowQR({
        uen: this.paymentID, // "201403121W", //Required: UEN of company
        amount: this.price, //Specify amount of money to pay.
        editable: true, //Whether or not to allow editing of payment amount. Defaults to false if amount is specified
        // expiry: "20201231", //Set an expiry date for the Paynow QR code (YYYYMMDD). If omitted, defaults to 5 years from current time.
        refNumber: this.longRefNumber(), //Reference number for Paynow Transaction. Useful if you need to track payments for recouncilation.
        company: this.businessName, //Company name to embed in the QR code. Optional.
      });
      console.log("PayNow code", code.output());
      return code.output(); //Outputs the qrcode to a UTF-8 string format, which can be passed to a QR code generation script to generate the paynow QR
    },
    longRefNumber() {
      // var iso = new Date().toISOString().split("T")[0].replaceAll("-", "");
      var iso = new Date().toISOString().split("T")[0].replace(/-/g, "");
      return `${iso}-${this.refNumber}`;
    },
  },
};
</script>

<style scoped>
.qr-wrapper {
  max-height: 95vw; /* setting height to width so it's a square 95vw*/
  text-align: center;
}
canvas {
  width: 80%;
  height: 80%;
  border: 10px solid white;
  border-radius: 4px;
}
.above-qr {
  margin: 0 auto;
  background-color: white;
  width: 80%;
  padding-top: 4px;
  margin-bottom: -4px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
}
.above-qr p {
  padding: 2px;
  margin: 0 8px;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
/* .identifier {
  text-transform: uppercase;
  margin-right: 3px;
} */
.tag {
  padding: 0 4px;
}
</style>